import { render } from "./TutorialFormPage.vue?vue&type=template&id=7e237810&ts=true"
import script from "./TutorialFormPage.vue?vue&type=script&lang=ts"
export * from "./TutorialFormPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__